// WCAG Compliant Color Generation for Avatars

/**
 * Generates a WCAG-compliant color pair (background, text) based on a string (e.g., user name/email).
 * Uses a predefined palette of accessible pairs to ensure readability.
 * The palette ensures High Contrast (usually 4.5:1 or higher) for the text against the background.
 */
export const getUserAvatarColor = (name: string): { bgcolor: string; color: string } => {
  const palette = [
    { bgcolor: '#1565c0', color: '#ffffff' }, // Blue 800
    { bgcolor: '#2e7d32', color: '#ffffff' }, // Green 800
    { bgcolor: '#c62828', color: '#ffffff' }, // Red 800
    { bgcolor: '#6a1b9a', color: '#ffffff' }, // Purple 800
    { bgcolor: '#0277bd', color: '#ffffff' }, // Light Blue 800
    { bgcolor: '#ad1457', color: '#ffffff' }, // Pink 800
    { bgcolor: '#f9a825', color: '#000000' }, // Yellow 800 (Black text)
    { bgcolor: '#d84315', color: '#ffffff' }, // Deep Orange 800
    { bgcolor: '#4e342e', color: '#ffffff' }, // Brown 800
    { bgcolor: '#37474f', color: '#ffffff' }, // Blue Grey 800
    { bgcolor: '#00695c', color: '#ffffff' }, // Teal 800
    { bgcolor: '#283593', color: '#ffffff' }, // Indigo 800
  ];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash % palette.length);
  return palette[index] ?? { bgcolor: '#1565c0', color: '#ffffff' };
};
